import React from "react";

export const DateOperations = (props) => {
  const today = new Date();
  const birthDate = new Date(props.birthday);
  let age_now = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age_now--;
    return age_now;
  }
  return <>{age_now >= 0 && age_now <= 100 ? <span>{age_now}</span> : 0}</>;
};

export const DateDMY = (props) => {
  const { created_at } = props;
  const time = new Date(created_at);
  const date =
    time.getDate() + "." + (time.getMonth() + 1) + "." + time.getFullYear();
  return <span>{date}</span>;
};

export const DateDMYhm = (props) => {
  const { created_at } = props;
  const time = new Date(created_at);
  const date =
    time.getDate() +
    "." +
    (time.getMonth() + 1) +
    "." +
    time.getFullYear() +
    " " +
    time.getHours() +
    ":" +
    time.getMinutes();
  return <span>{date}</span>;
};
